import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { FileUserRequestBody, FileUserResponse } from "./types";

export class FileUserAPI extends BaseAPI<
  FileUserRequestBody,
  FileUserResponse
> {
  protected route = ApiRoutes.file.user_list;
  protected method = RequestMethod.GET;
  protected params: string[] = ["sort_key", "sort_order"];
}
